<script setup lang="ts">
import brandedLoaderUrl from '@/assets/animations/branded-loader.riv?url'
import { onMounted, onUnmounted, ref } from 'vue'

import riveWASMResource from '@rive-app/canvas/rive.wasm?url'
import { Rive, RuntimeLoader } from '@rive-app/canvas'

RuntimeLoader.setWasmUrl(riveWASMResource)

let interval: ReturnType<typeof setInterval>
const currentIndex = ref(0)
const canvasRef = ref<HTMLCanvasElement | null>(null)
let r: Rive | null = null

const props = defineProps<{
  messages?: string[]
}>()
const messages = props.messages || ['Making sustainable living simple']

onMounted(() => {
  interval = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % messages.length
  }, 3000)

  if (canvasRef.value) {
    r = new Rive({
      src: brandedLoaderUrl,
      canvas: canvasRef.value,
      autoplay: true,
      stateMachines: 'State Machine 1',
      onLoad: () => {
        if (r) r.resizeDrawingSurfaceToCanvas()
      },
    })
    r.play()
  }
})

onUnmounted(() => {
  if (r) r.cleanup()
  if (interval) clearInterval(interval)
})
</script>

<template>
  <div class="LoadingScreen">
    <div class="LoadingScreen__Content">
      <canvas ref="canvasRef" />
      <div class="LoadingScreen__Messages">
        <Transition name="fade" mode="out-in">
          <p :key="currentIndex" class="LoadingScreen__Message">
            {{ messages[currentIndex] }}
          </p>
        </Transition>
      </div>
    </div>
  </div>
</template>

<style scoped>
.LoadingScreen {
  background-color: var(--color-white);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;

  & canvas {
    height: 124px;
  }

  & p {
    font-family: var(--font-family-domaine);
    font-size: 21px;
    margin: 0;
    width: 230px;
    text-align: center;
    line-height: 1.3;
  }
}

.LoadingScreen__Content {
  position: relative;
}

.LoadingScreen__Messages {
  position: absolute;

  p {
    margin: 20px auto;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.quote-container {
  min-height: 2em;
  text-align: center;
  font-size: 1.2rem;
}
</style>
